import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { collection, getDocs, getDoc, doc } from 'firebase/firestore'
import { db } from '../firebaseConfig'
import './style/Bestseller.css'

const Bestseller = () => {
  const navigate = useNavigate()
  const [bestsellerProducts, setBestsellerProducts] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)
  const [fade, setFade] = useState(true)
  const [heroText, setHeroText] = useState('Bestseller')

  useEffect(() => {
    const fetchBestsellers = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'products'))
        const fetchedProducts = querySnapshot.docs
          .map(doc => ({ id: doc.id, ...doc.data() }))
          .filter(product => product.bestseller && product.public)
        setBestsellerProducts(fetchedProducts)
      } catch (error) {
        console.error('Fehler beim Abrufen der Bestseller-Produkte:', error)
      }
    }

    const fetchText = async () => {
      try {
        const docRef = doc(db, 'settings', 'textHero')
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          const text = docSnap.data().text
          setHeroText(text)
        } else {
          console.warn('Dokument textHero existiert nicht.')
        }
      } catch (error) {
        console.error('Fehler beim Abrufen des Hero-Texts:', error)
      }
    }

    fetchBestsellers()
    fetchText()
  }, [])

  useEffect(() => {
    if (bestsellerProducts.length > 1) {
      const interval = setInterval(() => {
        setFade(false) // Erst ausblenden
        setTimeout(() => {
          setCurrentIndex(
            prevIndex => (prevIndex + 1) % bestsellerProducts.length
          )
          setFade(true) // Dann wieder einblenden
        }, 500) // Warte kurz, bis ausgeblendet ist
      }, 5000)

      return () => clearInterval(interval)
    }
  }, [bestsellerProducts])

  if (bestsellerProducts.length === 0) {
    return (
      <p style={{ textAlign: 'center', marginTop: '50px' }}>
        Aktuell keine Bestseller verfügbar.
      </p>
    )
  }

  const currentProduct = bestsellerProducts[currentIndex]

  return (
    <div id='bestseller'>
      <h1>{heroText}</h1>
      <div className={`bestseller-card ${fade ? 'fade-in' : 'fade-out'}`}>
        <img
          src={currentProduct.images[0]}
          alt={currentProduct.name}
          className='bestseller-image'
        />
        <div className='bestseller-info'>
          <h3 className='bestseller-title'>{currentProduct.name}</h3>
          <p className='bestseller-description'>{currentProduct.description}</p>
          <button
            className='bestseller-button'
            onClick={() => navigate(`/produkt/${currentProduct.id}`)}
          >
            Zum Produkt
          </button>
        </div>
      </div>
    </div>
  )
}

export default Bestseller
